import React, { Component } from 'react'
import styles from '../style.module.less'
import { observer } from 'mobx-react'
import { getMerchantInfo } from '@util'
import Store from './store'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
  }

  componentDidMount() {
    this.store.getHall()
    this.store.getMenu()
  }

  render() {
    const { address, name } = getMerchantInfo()
    const { hall, menu } = this.store
    return (
      <div>
        <img
          src="https://qnm.hunliji.com/FpIDU35HrH23ve7y4EG1LoTnjAeW"
          width={375}
        />
        <div className={styles.top}>
          <p className={styles.p1}>{name}</p>
          <div className={styles.hr} />
          <div className={styles.address}>
            <p className={styles.p2}>{address}</p>
            <img
              src="https://qnm.hunliji.com/FqXTqKxRIJus9TVXwT9huWt0VDvT"
              width={22}
            />
          </div>
        </div>
        <div className={styles.shadow} />
        <div className={styles.hall}>
          <p className={styles.p1}>宴会厅</p>
          {hall.map(item => (
            <div className={styles.itemBox}>
              <div className={styles.box1}>
                <img src={item.cover_url} />
                <div className={styles.des}>
                  <p className={styles.p5}>{item.name}</p>
                  <p className={styles.p4}>最多{item.max_table_num}桌</p>
                  <p className={styles.p4}>
                    {item.pillar || 0}立柱 层高{item.height || 0}m
                  </p>
                </div>
              </div>
              <div className={styles.btn}>查询档期</div>
            </div>
          ))}
        </div>

        <div className={styles.hall} style={{ marginTop: 12 }}>
          <p className={styles.p1}>菜单</p>
          {menu.map(item => (
            <div className={styles.itemBox}>
              <div className={styles.box1}>
                <img src={item.cover_path} />
                <div className={styles.des}>
                  <p className={styles.p5}>{item.name}</p>
                  <p className={styles.p4}>最多{item.max_table_num}桌</p>
                  <p className={styles.p4}>
                    {item.series.length || 0}份菜单 {item.series_count || 0}道菜
                  </p>
                </div>
              </div>
              <div className={styles.btn}>查询档期</div>
            </div>
          ))}
        </div>
      </div>
    )
  }
}
